function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0082C6",
  d: "M6.59 17.87l.93-1.64h3.62l-.88 1.55.06.09H8.45l-.93 1.65H5.65z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1E323D",
  d: "M6.59 17.87l-.94 1.65-.93-1.65-.93-1.64.93-1.65.93-1.65.94 1.65.93 1.65-.93 1.64z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D94D5",
  d: "M9.38 16.23H7.52l-.93-1.65-.94-1.65h1.87l.93 1.65h1.87l-.05.08.89 1.57z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1E323D",
  d: "M14.91 22.82l-.94 1.65-.93-1.65.93-1.65-.93-1.65h1.87l.93 1.65z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0082C6",
  d: "M18.63 22.82l-.93 1.65h-3.73l.94-1.65.93-1.65h3.73l-.94 1.65z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D94D5",
  d: "M15.84 17.87h1.86l.93 1.65.94 1.65h-3.73l-.93-1.65z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M10.24 17.87l.94 1.65.93-1.65z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0082C6",
  d: "M15.84 17.87l-.94 1.65h-1.86l-.93-1.65.93-1.65h3.73l-.93 1.65z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M11.18 19.52l.93-1.65.93 1.65z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1E323D",
  d: "M10.24 14.62h-.04l.02-.03-.01-.02h.02l.93-1.65.93 1.65.95 1.65-.95 1.65h-1.88l.94-1.65-.91-1.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D94D5",
  d: "M13.04 12.92h1.86l.94 1.65.93 1.65h-3.73l-.93-1.65-.93-1.65h1.86z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1E323D",
  d: "M7.53 19.52l.93-1.65.93 1.65.93 1.65-.93 1.65-.93 1.65-.93-1.65.93-1.65z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0082C6",
  d: "M13.12 22.82l-.93 1.65H8.46l.93-1.65.93-1.65h3.73l-.93 1.65z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D94D5",
  d: "M12.19 17.87l.93 1.65.93 1.65h-3.73l-.93-1.65-.93-1.65z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1E323D",
  d: "M7.43 9.65L8.36 8l.93 1.65.94 1.65-.94 1.65-.93 1.64-.93-1.64-.93-1.65z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0082C6",
  d: "M13.02 12.95h-1.86l-.93 1.64H8.36l.93-1.64.94-1.65h3.73z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D94D5",
  d: "M12.09 8l.93 1.65.94 1.65h-3.73l-.94-1.65L8.36 8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1E323D",
  d: "M1.93 19.54l.93-1.65.94 1.65.93 1.65-.93 1.65-.94 1.65-.93-1.65L1 21.19z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0082C6",
  d: "M7.53 22.84l-.94 1.65H2.86l.94-1.65.93-1.65h3.73z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D94D5",
  d: "M4.73 17.89l.93 1.65h1.87l.93 1.65H4.73l-.93-1.65-.94-1.65z"
}));

function SvgAtl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
}

export default __webpack_public_path__ + "ea7dc6b4edc0999bfd349f784f392017.svg";
export { SvgAtl as ReactComponent };